import { FCWithChildren } from '@types';
import React from 'react';
import { Button, Modal, ModalBody, WifiEnabledInstructions } from '@components';
import useLayoutContext from '@hooks/useLayoutContext';

type ModalWifiEnabledProps = {
  isOpen: boolean;
  onClose: () => void;
  preWiredKey?: string;
};

const ModalWifiEnabled: FCWithChildren<ModalWifiEnabledProps> = ({
  isOpen,
  onClose,
  preWiredKey,
}) => {
  const { pskEnabled } = useLayoutContext();
  return (
    <Modal
      customWebClass="xl:w-1/3 l:w-2/3 m:w-90"
      maxWidthClass="max-w-90"
      closeModal={onClose}
      isOpen={isOpen}
    >
      <ModalBody>
        <WifiEnabledInstructions preWiredKey={preWiredKey} />
        <div className="flex justify-center mt-6">
          <Button layout="secondary" className="w-32" onClick={onClose}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalWifiEnabled;
